// extracted by mini-css-extract-plugin
module.exports = {"switch":"switch_switch__1XyNZ","switch_label":"switch_switch_label__1WpAA","switch_input":"switch_switch_input__2COkH"};